module.exports = __webpack_public_path__ + "img/jerusalem_artichoke.5415bdb2.jpg";